import "moment/locale/nn";

import {downloadedLocalization, downloadingLocalization, failedToDownloadLocalization, urls} from "./localization.js";

import moment from "moment";

export const SET_CURRENT_LANGUAGE = "SET_CURRENT_LANGUAGE";

/**
 * Sätter aktuellt språk och laddar översättningsdata
 * 
 * @param {number} language
 * @returns {Function}
 */
export function setCurrentLanguage(language) {
    return async (dispatch, getState) => {
        
        const currentLanguage = getState().userSettings.currentLanguage;
        if (((!language || currentLanguage == language) && getState().localization.hasData) || getState().localization.downloading) {
            return;
        }

        if( language=="no" ){
            moment().locale("nn");
        }

        const url = urls[language];
        if (!url) {
            throw new Error(`No translation file is specified for ${language}`);
        }

        dispatch(downloadingLocalization());
        try {
            const languageData = await fetch(url);
            const json = await(languageData.json());
            dispatch(downloadedLocalization(json));

            dispatch({
                type: SET_CURRENT_LANGUAGE,
                language
            });

        } catch (error) {
            dispatch(failedToDownloadLocalization());
        }
    };
}